// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1WI1u","footer":"ReportModalFilter_footer__3DxFo"};